/*
 * Author: harper
 * File Created: Tuesday, 24-03-05 05:45 pm
 * Last Modified: Thursday, 25-06-12 10:14 am, by Dw
 */
import { useEffect } from 'react';
import { logger } from '@/src/utils/logger';
const ServiceWorker = () => {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          if (registration.scope === `${window.location.origin}/`) {
            registration.unregister().then(success => {
              if (success) {
                logger.log('Unregistered Service Worker for scope /');
              }
            });
          }
        });
      });
      void navigator.serviceWorker.register(`${process.env.NEXT_PUBLIC_PREFIX_PATH}/service-worker.js`).then(registration => {
        logger.log('scope is: ', registration.scope);
      }).catch(e => {
        logger.info('Service Worker registration failed:', e);
      });
    }
  }, []);
  return <div id="service-worker" data-sentry-component="ServiceWorker" data-sentry-source-file="index.tsx" />;
};
export default ServiceWorker;